import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import authService from "../services/authService";
import axios from "axios";
import Swal from "sweetalert2"; // Import SweetAlert
import ScoreModal from "../components/ScoreModal";

const Dashboard = () => {
  const [presentations, setPresentations] = useState([]);
  const [registrationCompleted, setRegistrationCompleted] = useState(false);
  const navigate = useNavigate();
  const [showPdf, setShowPdf] = useState(null);
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  const [selectedPresentation, setSelectedPresentation] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const user = authService.getCurrentUser();


  useEffect(() => {
    const user = authService.getCurrentUser();

    if (!user) {
      navigate("/login");
      return;
    }

    // ✅ Fetch user registration status
    const fetchRegistrationStatus = async () => {
      try {
        const response = await axios.get("https://doshfebackend.teemah.com.ng/api/auth/profile/", {
          headers: { Authorization: `Bearer ${user.access}` },
        });

        // ✅ If registration is completed, update state
        if (response.data.completed) {
          setRegistrationCompleted(true);
        }
      } catch (error) {
        console.error("Error fetching registration status:", error);
      }
    };

    // ✅ Fetch presentations
    const fetchPresentations = async () => {
      try {
        const response = await fetch("https://doshfebackend.teemah.com.ng/api/auth/presentations/", {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${user.access}`,
          },
        });

        if (!response.ok) {
          throw new Error("Failed to fetch presentations");
        }

        const data = await response.json();
        setPresentations(data);
      } catch (error) {
        console.error("Error:", error.message);
      }
    };

    fetchRegistrationStatus(); // ✅ Call this function
    fetchPresentations(); // ✅ Fetch presentations

  }, [navigate]);

  const handleViewPdf = (pdfUrl) => {
    if (isMobile) {
      Swal.fire({
        icon: "warning",
        title: "PDF Not Available on Mobile",
        text: "Please use a PC to view this document.",
        confirmButtonColor: "#3085d6",
      });
    } else {
      setShowPdf(pdfUrl);
    }
  };

  const handleViewScores = (presentationId) => {
    setSelectedPresentation(presentationId);
    setShowModal(true);
  };



  return (
    <div className="bg-yellow-100 min-h-screen p-6 mt-24">
      <h1 className="text-2xl font-bold text-blue-600 mb-4">Dashboard</h1>

      <div className="flex justify-between space-x-4">
        {/* Left Side - Registration Button */}
        <div>
          {registrationCompleted ? (
            <Link
              to="/view-registration" // Ensure this route exists
              className="bg-blue-500 text-white px-4 py-2 rounded mb-4 inline-block"
            >
              View Registration Form
            </Link>
          ) : (
            <Link
              to="/registration"
              className="bg-blue-500 text-white px-4 py-2 rounded mb-4 inline-block"
            >
              Register Student
            </Link>
          )}
        </div>

        {/* Right Side - Scoreboard Button */}
        <div>
          <Link
            to="/view-scoreboard/${student.id}" // Ensure this route exists
            className="bg-yellow-500 text-black px-4 py-2 rounded mb-4 inline-block"
          >
            View Score Board
          </Link>
        </div>
      </div>


      <div className="container mx-auto px-4">
        <h2 className="bg-yellow-500 p-4 rounded-3xl text-blue-500 text-2xl mb-6">Courses</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {presentations.slice().reverse().map((presentation) => (
  <div key={presentation.id} className="bg-white p-6 shadow-md rounded-lg">
    <h2 className="text-lg font-semibold">{presentation.title}</h2>
    <p className="text-gray-600">
      Uploaded on: {new Date(presentation.uploaded_at).toLocaleDateString()}
    </p>

    {isMobile ? (
      <img
        src={presentation.course_image}
        alt={presentation.title}
        className="mt-4 w-full h-[150px] md:h-[300px] object-cover rounded-lg"
      />
    ) : (
      <iframe
        src={`${presentation.view_url}#toolbar=0&zoom=FitH`}
        className="mt-4 w-full h-[300px] md:h-[300px] border rounded-lg"
        title={presentation.title}
      ></iframe>
    )}

    {/* ✅ Buttons in a row - Show PDF (Left) and View Scores (Right) */}
    <div className="flex justify-between mt-4">
      <button
        onClick={() => handleViewPdf(presentation.view_url)}
        className="bg-blue-500 text-white px-6 py-3 rounded-lg hover:bg-blue-600"
      >
        Show PDF
      </button>

      <button
        onClick={() => handleViewScores(presentation.id)}
        className="bg-green-500 text-white px-6 py-3 rounded-lg hover:bg-green-600"
      >
        View Scores
      </button>
    </div>
  </div>
))}


        </div>


        {/* ✅ Fullscreen PDF Viewer */}
        {showPdf && (
          <div className="fixed inset-0 bg-black bg-opacity-80 flex justify-center items-center z-50">
            <div className="relative w-[90%] md:w-[90%] lg:w-[90%] h-[90%] md:h-[95%] bg-white p-4 rounded-lg shadow-lg">
              {/* Close Button */}
              <button
                onClick={() => setShowPdf(null)}
                className="absolute top-4 right-4 bg-red-600 text-white px-4 py-2 rounded-lg"
              >
                Close
              </button>

              {/* PDF Display */}
              <iframe
                src={`${showPdf}#toolbar=0&zoom=FitH`}
                className="w-full h-full border-none rounded-md"
                title="Full Screen PDF"
                {...(isMobile ? { sandbox: "allow-scripts allow-same-origin" } : {})}
              // onClick={() => handleViewPdf(presentation.view_url)}
              ></iframe>








            </div>
          </div>
        )}
      </div>
      {/* Score Modal */}
      <ScoreModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        presentationId={selectedPresentation}
        authToken={user?.access}
      />
    </div>
  );
};

export default Dashboard;
